module.exports = __webpack_public_path__ + "img/start_landscape_handschrift_anim.59052255.png";